export type RoleKey =
  | "qb"
  | "st"
  | "wr"
  | "rb"
  | "lb"
  | "db"
  | "dl"
  | "dc"
  | "te"
  | "ol"
  | "s"
  | "def";

export type FieldZoneLayout = {
  rows: string[][];
};

export type RoleConfig = {
  id: RoleKey;
  displayName: string;
  featureFlags?: Record<string, boolean>;
  labels?: Record<string, string>;
  fieldZones?: FieldZoneLayout;
};

// Central place to keep per-role display names and toggles; expand as we consolidate UI.
export const roleConfigs: Record<RoleKey, RoleConfig> = {
  qb: {
    id: "qb",
    displayName: "Quarterback",
    fieldZones: { rows: [["7", "8", "9"], ["4", "5", "6"], ["1", "2", "3"]] },
  },
  st: {
    id: "st",
    displayName: "Safety",
    fieldZones: { rows: [["7", "8", "9"], ["4", "5", "6"], ["1", "2", "3"]] },
  },
  wr: { id: "wr", displayName: "Wide Receiver" },
  rb: { id: "rb", displayName: "Running Back" },
  lb: { id: "lb", displayName: "Linebacker" },
  db: { id: "db", displayName: "Defensive Back" },
  dl: { id: "dl", displayName: "Defensive Line" },
  dc: { id: "dc", displayName: "Defensive Coordinator" },
  te: { id: "te", displayName: "Tight End" },
  ol: { id: "ol", displayName: "Offensive Line" },
  s: { id: "s", displayName: "Safety" },
  def: { id: "def", displayName: "Defense" },
};

export function getRoleConfig(role: RoleKey): RoleConfig {
  return roleConfigs[role];
}
